import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MapModule } from '@eview/features/ui/map/map.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GetAlertsComponent } from './get-alerts.component';

export const routes: Routes = [
  {
    path: '',
    component: GetAlertsComponent,
    outlet: 'dashboard'
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    MapModule,
    FontAwesomeModule
  ],
  declarations: [GetAlertsComponent],
  exports: [GetAlertsComponent]
})
export class GetAlertsModule {}
